export enum TodayDetailTexts {
    TITLE = 'Heute',
    UNIT_MONEY = '€',
    UNIT_CONSUMPTION = 'kWh',
    LABEL_COMPARISON_TODAY = 'HEUTE',
    MORE = 'mehr',
    LESS = 'weniger',
    LABEL_FRAGMENT_LAST = 'als letzten',
    LABEL_FRAGMENT_IDENTICAL = 'identisch',
    LABEL_FRAGMENT_TO_LAST = 'zum letzten',
    LABEL_FRAGMENT_PERCENT = '%'
}
